import { publish } from '../../pubsub';
import useContainerProps from '../helpers/useContainerProps';

/**
 * Fire when user change budget filter in any component
 * @param {Object} container
 * @param {Object} budgetMaximumAmount
 * @param {Object} cardType
 *
 */
export default (container, budgetMaximumAmount, cardType = 'fare') => {
  const { eventType } = useContainerProps(container);
  publish(`em.${cardType}.${eventType}.budget`, {
    budgetMaximumAmount
  });
};
